import { ConnectionGroupModel } from '@em/models/restapi/ConnectionGroup.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class ConnectionGroupCollectionModel extends ChangeTrackedCollectionModel<ConnectionGroupModel> {
    public constructor() {
        super(ConnectionGroupModel);
    }
}
